import styled from 'styled-components';

import { Button } from '@savgroup-front-common/core/atoms/button';
import { mediaQuery } from '@savgroup-front-common/core/grid/helpers';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $DeliveredSparePartActionButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  padding: ${spacing('sm')} ${spacing('xxl')};
  height: auto;

  &:active,
  &:focus,
  &:active:hover,
  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryHover};
  }

  ${mediaQuery.xs`
    width: 100%;
    margin-top: ${spacing('xl')};
  `}
`;

export const $DeliveredSparePartInfoModal = styled('div')`
  padding-left: ${spacing('lg')};
  padding-top: ${spacing('sm')};
  display: flex;
`;
